import AuthStateHelper from '../authStateHelper.js';
import axios from "axios";
import { API_URL,API_ROUTES } from '../../constants/constants.js';
import router from "@/router"; // Importa tu instancia del router


// Función para decodificar una cadena base64url
function base64UrlDecode(base64Url) {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
    return JSON.parse(jsonPayload);
}

// Función para obtener el payload de un JWT
function getJwtPayload(jwt) {
    const payloadBase64Url = jwt.split('.')[1];
    return base64UrlDecode(payloadBase64Url);
}

const axiosSinInterceptor = axios.create();

axios.interceptors.request.use(async function(config) {
    let accessToken = AuthStateHelper.getAccessToken();
    if (accessToken) {
        const payload = getJwtPayload(accessToken);
        const now = Math.floor(Date.now() / 1000); // tiempo actual en segundos
        const dif = payload.exp - now;
        
        if (dif < 0 || dif < 300) { // El accessToken expiró o expira en menos de 5 minutos
            let refreshToken = AuthStateHelper.getRefreshToken();
            console.log("El accessToken ha expirado o está por expirar, intentando refrescar...");
            try {
                const response = await axiosSinInterceptor.post(API_URL+API_ROUTES.REFRESH, { refreshToken });
                console.log("Respuesta del servidor al refrescar el token:", response);
                if (response?.data.accessToken) {
                    accessToken = response.data.accessToken;
                    AuthStateHelper.setAuth({ accessToken, refreshToken });
                } else {
                    AuthStateHelper.deleteAuth();
                    router.push("/login"); // Redirige al login
                    alert("Tu sesión ha expirado. Por favor, inicia sesión nuevamente.");
                }
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    AuthStateHelper.deleteAuth();
                    router.push("/login"); // Redirige al login
                    alert("Tu sesión ha expirado. Por favor, inicia sesión nuevamente.");
                } else {
                    throw error;
                }
            }
        }

        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
});